const common = {
  // Navigation
  "nav.about": "公司簡介",
  "nav.technology": "工藝技術",
  "nav.aesthetics": "服務項目",
  "nav.compliance": "品質合規",
  "nav.contact": "聯絡我們",
  
  // Hero Section
  "hero.badge": "始於 2004：二十載專注，鑄就卓越品質",
  "hero.title1": "精密鋁合金",
  "hero.title2": "表面工程專家",
  "hero.description": "專精 2000/6000/7000 系列高強度鋁合金 Type III 硬質陽極處理",
  "hero.description2": "承襲職人精神，推動數位與永續轉型",
  "hero.learnMore": "了解更多",
  "hero.contactUs": "聯繫我們",
  
  // About Section
  "about.subtitle": "ABOUT HSIN YU ENTERPRISE",
  "about.title1": "自 2004 年創立以來",
  "about.title2": "薪瑀企業深耕精密表面處理技術已逾 20 年",
  "about.description": "我們專精於 2000、6000、7000 系列高強度鋁合金的硬質陽極處理，具備處理航太級高強度材料超過 20 年的深厚經驗。目前正全面轉型智慧製造，導入 CQI-12 與 IATF 16949 管理精神，為國際大廠提供穩定且合規的綠色供應鏈方案。",
  "about.viewTechnology": "查看工藝技術",
  "about.qualityCompliance": "品質合規",
  "about.stat.founded": "創立年份",
  "about.stat.experience": "年專業經驗",
  "about.stat.series": "鋁合金系列",
  "about.stat.traceability": "品質追溯",
  
  // Certifications Section
  "cert.title": "國際認證體系",
  "cert.description": "嚴格遵循國際標準，確保每一道工序可追溯",
  "cert.certified": "已認證",
  "cert.applied": "精神應用",
  "cert.iso9001": "ISO 9001",
  "cert.iso9001.desc": "品質管理系統認證",
  "cert.iso14001": "ISO 14001",
  "cert.iso14001.desc": "環境管理系統認證",
  "cert.iatf": "IATF 16949",
  "cert.iatf.desc": "汽車產業品質管理精神",
  "cert.cqi12": "CQI-12",
  "cert.cqi12.desc": "電鍍系統特殊製程評估",
  "cert.rohs": "RoHS 合規",
  "cert.rohs.desc": "符合歐盟有害物質限制指令",
  "cert.reach": "REACH 合規",
  "cert.reach.desc": "符合歐盟化學品註冊評估授權",
  "cert.ca65": "加州 65 法案",
  "cert.ca65.desc": "符合美國加州安全飲用水法案",
  
  // ESG Section
  "esg.subtitle": "SUSTAINABILITY & ESG",
  "esg.title": "永續與 ESG 實踐",
  "esg.description": "薪瑀企業深信，企業的永續發展與環境保護密不可分。我們積極投入 ESG 實踐，從環境保護、社會責任到公司治理，全方位落實永續經營理念",
  "esg.environment": "環境保護 (E)",
  "esg.env1": "廢水處理系統符合國際標準",
  "esg.env2": "持續降低碳排放與能源消耗",
  "esg.env3": "使用環保電鍍材料與製程",
  "esg.env4": "定期進行環境影響評估",
  "esg.social": "社會責任 (S)",
  "esg.soc1": "提供安全健康的工作環境",
  "esg.soc2": "重視員工培訓與職涯發展",
  "esg.soc3": "支持在地社區發展計畫",
  "esg.soc4": "建立公平透明的供應鏈管理",
  "esg.governance": "公司治理 (G)",
  "esg.gov1": "建立完善的內部控制制度",
  "esg.gov2": "遵循商業道德與誠信原則",
  "esg.gov3": "定期揭露企業營運資訊",
  "esg.gov4": "持續優化風險管理機制",
  "esg.stat1": "碳排放減少目標",
  "esg.stat1.year": "(2025年)",
  "esg.stat2": "廢水處理",
  "esg.stat2.sub": "達標率",
  "esg.stat3": "原物料",
  "esg.stat3.sub": "可追溯性",
  "esg.stat4": "重大工安",
  "esg.stat4.sub": "事故紀錄",
  
  // Services Section
  "services.subtitle": "SERVICES & TECHNOLOGY",
  "services.title": "服務項目",
  "services.description": "提供全方位的電鍍表面處理解決方案，從工藝設計到品質管控，我們以專業技術與智慧製造，滿足各產業的嚴格需求",
  "services.automotive": "汽車零組件",
  "services.automotive.desc": "符合 IATF 16949 精神",
  "services.precision": "精密五金",
  "services.precision.desc": "高精度表面處理",
  "services.sports": "運動器材",
  "services.sports.desc": "耐用與美觀兼具",
  "services.medical": "醫療設備",
  "services.medical.desc": "符合醫療級標準",
  "services.medicalDevice": "醫療器材",
  "services.medicalDevice.title": "人工關節專用處理",
  "services.medicalDevice.desc": "提供具備優異生體相容性與極高穩定性的轉化膜，符合醫療輔具的嚴苛標準。我們的表面處理技術確保人工關節在長期使用中保持穩定性能，為患者提供安全可靠的醫療解決方案。",
  "services.medicalDevice.tag1": "生體相容性",
  "services.medicalDevice.tag2": "醫療級標準",
  "services.medicalDevice.tag3": "長期穩定",
  "services.mold": "精密模具",
  "services.mold.title": "硬陽 + 鐵氟龍複合處理",
  "services.mold.desc": "專為包裝容器模具開發，結合硬陽的耐用與鐵氟龍的不沾特性，大幅提升脫模效率與壽命。此創新複合處理技術為模具產業帶來革命性的性能提升。\u00A0 \u00A0 \u00A0\u00A0",
  "services.mold.tag1": "不沾特性",
  "services.mold.tag2": "高脫模效率",
  "services.mold.tag3": "延長壽命",
  "services.bicycle": "高階自行車與機車",
  "services.bicycle.title": "6000 & 7000 系列關鍵零組件",
  "services.bicycle.desc": "針對 6000 與 7000 系列高強度材料，提供避震器、連桿等關鍵零組件的表面強化。我們的專業處理技術確保這些高性能零件在極端條件下仍能保持卓越性能。",
  "services.bicycle.tag1": "避震器專用",
  "services.bicycle.tag2": "高強度材料",
  "services.bicycle.tag3": "極端耐用",
  
  // Technology Section
  "tech.subtitle": "TYPE III HARDCOAT ANODIZING",
  "tech.title": "工藝技術",
  "tech.description": "採用先進電化學製程技術，將鋁合金表面轉化為高硬度 Al₂O₃ 陶瓷層，提供卓越的耐磨性與防護性能，符合 CQI-12 特殊製程評估標準",
  "tech.natural": "硬質陽極處理（本色）",
  "tech.natural.sub": "Natural Finish",
  "tech.natural.desc": "透過精密電化學製程，將 AL 2000/6000/7000 系列鋁合金表面轉化為高硬度 Al₂O₃ 陶瓷結構。此製程在微米級精度控制下進行，確保鍍層均勻性與結構完整性，提供卓越的機械防護性能。",
  "tech.natural.feat1": "與基材一體成型",
  "tech.natural.feat1.desc": "將鋁基材轉化為 Al₂O₃ 陶瓷結構，形成與基材一體化的防護層，絕不剝落",
  "tech.natural.feat2": "高硬度耐磨耗",
  "tech.natural.feat2.desc": "硬度可達 HV 400-600，顯著提升表面耐磨性與使用壽命",
  "tech.natural.feat3": "微米級精度控制",
  "tech.natural.feat3.desc": "精確控制表面微觀結構，達到尺寸公差符合設計規格",
  "tech.black": "硬質陽極處理（硬黑）",
  "tech.black.sub": "Hard Black Finish",
  "tech.black.desc": "透過精密化學拋光（Chemical Polishing）技術，在 Type III 硬質陽極處理基礎上，整合高飽和度黑色染料技術。染料分子深度滲透至多孔氧化層結構中，形成持久耐用的深黑色外觀，同時保留完整的物理防護性能與抗紫外線特性。",
  "tech.black.feat1": "保留硬陽物理特性",
  "tech.black.feat1.desc": "同等高強度防護性能，展現消光或亮面黑視覺表現",
  "tech.black.feat2": "零色差高級質感",
  "tech.black.feat2.desc": "高飽和度黑色染料深度滲透，呈現均勻一致的深邃黑色美學",
  "tech.black.feat3": "抗 UV 不褪色",
  "tech.black.feat3.desc": "優異的抗紫外線性能，長期使用不褪色、不變質",
  "tech.note.title": "Technical Note: 2000 Series Alloy Expertise",
  "tech.note.desc": "薪瑀企業具備處理 AL 2000 系列高銅含量鋁合金的專業技術能力。2000 系列因其高強度特性廣泛應用於航太與高端運動器材，但其高銅含量使陽極處理難度顯著提升。我們透過精密的製程參數控制與專屬配方，成功克服此技術挑戰，確保 2000 系列合金同樣能獲得均勻、高品質的硬質陽極處理效果。",
  "tech.consult": "諮詢技術規格",
  
  // Product Features Section
  "product.subtitle": "PRODUCT FEATURES",
  "product.title": "產品介紹",
  "product.description": "專為高強度鋁合金設計的表面處理技術,提供卓越的耐磨性與防護性能,適用於高端自行車零件與運動器材",
  "product.natural": "硬質陽極處理(本色)",
  "product.natural.desc": "專為 7075 與 6066 鋁合金設計的硬質陽極處理技術。透過精密的電化學製程,在鋁材表面形成堅硬的氧化層,提供卓越的耐磨性與耐腐蝕性能,同時保留金屬原有的自然質感與光澤。",
  "product.natural.feat1": "適用於 7075 & 6066 鋁合金",
  "product.natural.feat2": "卓越的耐磨性與表面硬度",
  "product.natural.feat3": "保留原始金屬質感與光澤",
  "product.natural.feat4": "優異的耐腐蝕防護性能",
  "product.black": "硬質陽極處理(硬黑)",
  "product.black.desc": "結合高強度防護與深邃黑色美學的硬質陽極處理技術。同樣適用於 7075 與 6066 鋁合金,在提供頂級耐磨保護的同時,賦予產品持久耐用的深黑色外觀,完美適用於高端自行車零件與專業運動器材。",
  "product.black.feat1": "同等高強度防護性能",
  "product.black.feat2": "深邃持久的黑色美學外觀",
  "product.black.feat3": "適用於高端自行車零件",
  "product.black.feat4": "專業運動器材首選表面處理",
  "product.inquire": "詢問產品規格",
  
  // Compliance Section
  "compliance.subtitle": "GLOBAL COMPLIANCE",
  "compliance.title": "全球供應鏈合規保證",
  "compliance.description": "我們嚴格執行 Fox Factory 供應商 193 題稽核標準，落實 ESG 永續經營",
  "compliance.quality": "品質標準",
  "compliance.quality1": "遵循 ISO 9001 品質管理系統",
  "compliance.quality2": "導入 CQI-12 電鍍系統評核",
  "compliance.quality3": "應用 IATF 16949 管理精神",
  "compliance.quality4": "PPAP 數據管理與追溯",
  "compliance.environment": "環境標準",
  "compliance.env1": "遵循 ISO 14001 環境管理系統",
  "compliance.env2": "配備專業廢水處理設施",
  "compliance.env3": "全製程符合 RoHS 3.0 規範",
  "compliance.env4": "符合 REACH 化學品法規",
  "compliance.international": "國際法規",
  "compliance.int1": "嚴格遵守美國加州 65 法案",
  "compliance.int2": "確保全球貿易合規性",
  "compliance.int3": "定期更新法規符合性",
  "compliance.int4": "提供完整合規文件",
  "compliance.social": "社會責任",
  "compliance.soc1": "符合 RBA 責任商業聯盟準則",
  "compliance.soc2": "守護勞工權益與職業安全",
  "compliance.soc3": "落實誠信經營與商業道德",
  "compliance.soc4": "建立透明供應鏈管理",
  
  // CTA Section
  "cta.title1": "PARTNER WITH",
  "cta.title2": "EXCELLENCE",
  "cta.description": "攜手薪瑀企業 / 共創綠色智慧製造未來",
  "cta.button": "立即諮詢",
  
  // Contact Section
  "contact.title": "聯絡我們",
  "contact.description": "歡迎與我們聯繫，我們將竭誠為您服務",
  "contact.phone": "電話",
  "contact.email": "電子郵件",
  "contact.address": "地址",
  "contact.addressValue": "新北市新莊區新樹路 268 巷 35-1 號",
  "contact.openMap": "Open in Google Maps",
  "contact.form.name": "姓名",
  "contact.form.namePlaceholder": "請輸入您的姓名",
  "contact.form.company": "公司名稱",
  "contact.form.companyPlaceholder": "請輸入公司名稱",
  "contact.form.email": "電子郵件",
  "contact.form.phone": "電話",
  "contact.form.message": "需求說明",
  "contact.form.messagePlaceholder": "請描述您的需求或問題",
  "contact.form.submit": "送出諮詢",
  
  // Footer
  "footer.companyName": "薪瑀企業有限公司",
  "footer.companyNameEn": "Hsin Yu Enterprise Co., Ltd.",
  "footer.tagline": "精密鋁合金表面工程專家 | 始於 2004",
  "footer.newsletter": "訂閱技術電子報",
  "footer.subscribe": "訂閱",
  "footer.aboutUs": "關於我們",
  "footer.coreTech": "核心技術",
  "footer.certifications": "品質認證",
  "footer.typeIII": "Type III 硬質陽極",
  "footer.matte": "霧面處理",
  "footer.polish": "亮面拋光",
  "footer.qualityMgmt": "品質管理",
  "footer.copyright": "© 2026 Hsin Yu Enterprise Co., Ltd. All Rights Reserved.",
  
  // Language
  "lang.zh": "中文",
  "lang.en": "English"
};

export default common;
